export default {
      id: "right-arrow-hint-usage",
      viewBox: "0 0 5 10",
      url: "static/docker-35e621d613051bbda5b8b67fc5bb152e/images/" + "sprite.svg#right-arrow-hint-usage",
      toString: function () {
        return this.url;
      }
    }